import type { LanguageISO } from "@providers"

export interface SpecialProject {
  lang: LanguageISO
  text: string
  url?: string
  slug?: string
  in_journal?: boolean
}

export interface SpecialProjectOutput {
  lang: LanguageISO
  text: string
  url: string
  slug: string
  in_journal: boolean
}

export function SpecialProjectsSerializer(
  data?: SpecialProject[],
): SpecialProjectOutput[] {
  if (data && data.length > 0) {
    return data.map((project) => {
      return {
        lang: project.lang,
        text: project.text,
        url: project.url ?? "",
        slug: project.slug ?? "",
        in_journal: project.in_journal ?? false,
      }
    })
  }

  return []
}
